import { connect } from 'react-redux';
import DemoWidget from '../components/DemoWidget';
const mapStateToProps = (state, ownProps) => {
    const payloadSettings = Object.assign({}, state.nodeWidgetCustomization);
    const settings = payloadSettings
        ? {
            localization: payloadSettings.localizations,
            theme: payloadSettings.theme,
            medium: payloadSettings.medium,
            small: payloadSettings.small,
        }
        : null;
    return Object.assign(Object.assign({}, ownProps), { settings, widget_id: state.chatFlow.widget_id });
};
const mapDispatchToProps = (_dispatch, ownProps) => {
    return Object.assign({}, ownProps);
};
export default connect(mapStateToProps, mapDispatchToProps)(DemoWidget);
